module.exports = __webpack_public_path__ + "assets/img/photovoltaic.62e98cf3.png";